<template>
  <div class="inline-flex items-center px-1 py-[2px] rounded whitespace-nowrap bg-orange-200">
    <CText el="span" variant="system-xs">{{ t('will_be_discontinued') }}</CText>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<script lang="ts">
export default defineComponent({
  name: 'DiscontinuedLabel',
});
</script>
